import { fontSize, font, color } from '../../theme'
import styled from 'styled-components'
import { ButtonElementProps } from '.'

export const ButtonElement = styled.button<ButtonElementProps>`
  ${({ flex }) => (flex ? 'flex: 1; justify-content: center; align-items: center' : '')}
  font-size: ${fontSize.regular};
  user-select: none;
  font-family: ${font.sansationRegular};
  text-align: center;
  line-height: 35px;
  height: 35px;
  min-width: 110px;
  border: 0;
  margin: ${({ margin }) => margin || '5px'};
  background-color: ${({ backgroundColor }) => backgroundColor || color.content};
  cursor: pointer;
  display: ${({ flex }) => (flex ? 'flex' : 'inline-block')};
  color: ${({ color: fontColor }) => fontColor || color.whiteBlue};
  &:active {
    outline: 0;
    background-color: ${({ activeBacgroundColor }) => activeBacgroundColor || color.oceanBlue};
    color: ${({ activeColor }) => activeColor || color.whiteBlue};
  }
`
